__turbopack_context__.v({
  "adminItem": "gallery-module__0H54GG__adminItem",
  "adminList": "gallery-module__0H54GG__adminList",
  "adminThumb": "gallery-module__0H54GG__adminThumb",
  "adminToolbar": "gallery-module__0H54GG__adminToolbar",
  "dragged": "gallery-module__0H54GG__dragged",
  "dropTarget": "gallery-module__0H54GG__dropTarget",
  "editPreview": "gallery-module__0H54GG__editPreview",
  "flip": "gallery-module__0H54GG__flip",
  "gallery": "gallery-module__0H54GG__gallery",
  "galleryItem": "gallery-module__0H54GG__galleryItem",
  "galleryItemButton": "gallery-module__0H54GG__galleryItemButton",
  "galleryItemSelected": "gallery-module__0H54GG__galleryItemSelected",
  "handle": "gallery-module__0H54GG__handle",
  "header": "gallery-module__0H54GG__header",
  "image": "gallery-module__0H54GG__image",
  "imageWrapper": "gallery-module__0H54GG__imageWrapper",
  "images": "gallery-module__0H54GG__images",
  "scaleFadeIn": "gallery-module__0H54GG__scaleFadeIn",
  "stage": "gallery-module__0H54GG__stage",
  "thumbnailButton": "gallery-module__0H54GG__thumbnailButton",
  "thumbnails": "gallery-module__0H54GG__thumbnails",
  "title": "gallery-module__0H54GG__title",
  "upload": "gallery-module__0H54GG__upload",
  "uploadButtons": "gallery-module__0H54GG__uploadButtons",
  "uploadError": "gallery-module__0H54GG__uploadError",
  "uploadForm": "gallery-module__0H54GG__uploadForm",
  "wrapper": "gallery-module__0H54GG__wrapper",
  "zoomed": "gallery-module__0H54GG__zoomed",
});
